import { render, staticRenderFns } from "./SimpleText.vue?vue&type=template&id=0f0a0a99&"
import script from "./SimpleText.vue?vue&type=script&lang=js&"
export * from "./SimpleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports